import { User } from '../redux/reducers/user'
import { fetchRequest } from '../services/http.service'

export const GET_USER_URL = '/users/'
export const PUT_USER_URL = '/users/territory'

export const getUsersRequest = () =>
  fetchRequest.get<User[]>(GET_USER_URL)

export const getUserRequest = (userId: string) =>
  fetchRequest.get<User>(GET_USER_URL+'/'+userId)

export const updateUserTerritoryRequest = (territoryId: number) => 
  fetchRequest.put<User>(PUT_USER_URL+'?territoryId='+territoryId, '')